// extracted by mini-css-extract-plugin
module.exports = {"resultsWrapper":"styles_resultsWrapper__n1jwo","matchList":"styles_matchList__1kemh"};